var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleInNeed2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 20.97a10.938 10.938 0 0 1 4.13-8.46 7.565 7.565 0 0 0-4.5-1.51A7.69 7.69 0 0 0 5 18.58V22h8zM35 20.97V22h8v-3.42A7.69 7.69 0 0 0 35.37 11a7.565 7.565 0 0 0-4.5 1.51A10.938 10.938 0 0 1 35 20.97zM15 22v3h18v-4.03a9 9 0 0 0-18 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 29h-45a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleInNeed2);
export default __webpack_public_path__ + "static/media/People-in-need-2.85024e46f4b8a1040b4189e0bb5a6ca2.svg";
export { ForwardRef as ReactComponent };